import React, { useEffect } from 'react';
import { useLocalStorage } from './hooks/useLocalStorage';
import Header from './components/modern/Header';
import Hero from './components/modern/Hero';
import SkillsSection from './components/modern/SkillsSection';
import ExperienceSection from './components/modern/ExperienceSection';
import ProjectsSection from './components/modern/ProjectsSection';
import EducationSection from './components/modern/EducationSection';
import AchievementsSection from './components/modern/AchievementsSection';
import BlogSection from './components/modern/BlogSection';
import Footer from './components/modern/Footer';

import {
  greeting,
  socialMediaLinks,
  skillsSection,
  techStack,
  workExperiences,
  bigProjects,
  educationInfo,
  achievementSection,
  blogSection,
  contactInfo,
} from './portfolio';

function App() {
  const [isDark, setIsDark] = useLocalStorage('isDark', false);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  const toggleDarkMode = () => {
    setIsDark(!isDark);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <div className={isDark ? 'dark' : ''}>
      <Header isDark={isDark} toggleDarkMode={toggleDarkMode} scrollToSection={scrollToSection} />
      <main className="pt-20">
        <Hero greeting={greeting} socialMediaLinks={socialMediaLinks} contactEmail={contactInfo.email_address} />
        {skillsSection.display && (
          <SkillsSection skillsSection={skillsSection} techStack={techStack} />
        )}
        {workExperiences.display && (
          <ExperienceSection workExperiences={workExperiences} />
        )}
        {bigProjects.display && (
          <ProjectsSection bigProjects={bigProjects} />
        )}
        {educationInfo.display && (
          <EducationSection educationInfo={educationInfo} />
        )}
        {achievementSection.display && (
          <AchievementsSection achievementSection={achievementSection} />
        )}
        {blogSection.display && (
          <BlogSection blogSection={blogSection} />
        )}
      </main>
      <Footer socialMediaLinks={socialMediaLinks} contactInfo={contactInfo} />
    </div>
  );
}

export default App;
